import React, { useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import './signin.style.scss';
import { Redirect, Route, Switch } from 'react-router-dom';
import { RoutePath } from '../../../data';
import Form from './form/form.index';
import Forget from './forgetPassword/forgetpassword.index';
import Connecter from './connectServer/connectserver.index';
import { ReduxState } from 'interface';
import { Modal } from 'react-bootstrap';
import { Button, TextField } from '@material-ui/core';
import { serverAddress } from 'scripts/storage';
import { MessageBridge } from 'scripts/messageBridge';

const Signin: React.FC<ConnectedProps<typeof connector>> = function (props: ConnectedProps<typeof connector>) {
    const [show, setShow] = useState(false);
    const LANG = props.lang.signin;
    const [serverAdd, setServerAdd] = useState(serverAddress.get());

    useEffect(() => {
        MessageBridge.message('SCREEN_KEEP_ALIVE_STATUS', false);
    }, []);

    return (
        <div className="kiosk-register-signin">
            <Modal show={show} className={`ucheck-kiosk-modal register-modal`} size={'lg'} centered>
                <i onClick={() => setShow(false)} className="material-icons close-icon">
                    close
                </i>
                <div className="ucheck-modal-body">
                    <p>{LANG.text}</p>
                    <TextField
                        placeholder={serverAdd ? serverAdd : ''}
                        id="standard-basic"
                        label={LANG.serverAdd}
                        onChange={(e) => setServerAdd(e.target.value)}
                    />
                </div>
                <div className="ucheck-modal-footer">
                    <Button
                        className="cancel-button"
                        onClick={() => {
                            if (serverAdd) serverAddress.set(serverAdd);
                            setShow(false);
                        }}
                    >
                        {LANG.submit}
                    </Button>
                    <Button className="cancel-button" onClick={() => setShow(false)}>
                        {LANG.cancel}
                    </Button>
                </div>
            </Modal>
            <span className="material-icons-outlined" onClick={() => setShow(true)}>
                dns
            </span>
            <div className="signin">
                <Switch>
                    <Route path={RoutePath.register.signIn.connectServer} component={Connecter} />
                    <Route path={RoutePath.register.signIn.password} component={Forget} />
                    <Route path={RoutePath.register.signIn.form} component={Form} />
                    <Route path="*">
                        <Redirect to={RoutePath.register.signIn.form} />
                    </Route>
                </Switch>
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    lang: state.lang,
    dir: state.direction,
});

const connector = connect(mapStateToProps);
export default connector(Signin);
